<template>
  <div class="w-full">
    <VField :name="name" v-slot="{ field, errors }">
      <textarea
        :name="Math.random()"
        :rows="rows"
        type="text"
        v-bind="field"
        :maxlength="maxLength"
        :placeholder="placeholder"
        @input="input"
        class="w-full bg-white"
        :class="[
          errors[0]
            ? 'border border-red-500'
            : hasBorder
            ? 'border border-gray-400'
            : '',
        ]"
      />
      <div v-if="errors[0]" class="text-red-500 text-xs -mt-2 ms-1 mb-2 font-bold">
        <p v-text="errors[0]" class="font-12" />
      </div>
    </VField>
  </div>
</template>

<script>
import { Field } from "vee-validate";
export default {
  components: {
    VField: Field,
  },
  props: {
    classes: {
      type: String,
      required: false,
      default: "",
    },

    maxLength: {
      type: String || null,
      required: false,
      default: null,
    },
    name: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
    size: {
      type: String,
      required: false,
      default: "2xl",
      validate: () => "lg" || "2xl" || "full",
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasBorder: {
      type: Boolean,
      required: false,
      default: false,
    },
    rows: {
      type: String,
      default: "3",
    },
  },
  setup(props, context) {
    const isPasswordVisible = ref(false);
    const input = (e) => {
      context.emit("updated", e.target.value);
    };
    const actionClicked = () => {
      context.emit("action");
    };
    return {
      input,
      actionClicked,
      isPasswordVisible,
    };
  },
};
</script>

<style scoped>
.input-container {
  height: 130px;
}

textarea {
  border-radius: 10px;
  padding: 6px 10px;
  resize: none;
}
</style>
